/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Files_Error_Causes_RetriedInputs */



/**
* | output |
* | --- |
* | "{count} files queued again" |
*
* @param {Files_Error_Causes_RetriedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const files_error_causes_retried = /** @type {((inputs: Files_Error_Causes_RetriedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Files_Error_Causes_RetriedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Dateien erneut eingereiht`)
	return /** @type {LocalizedString} */ (`${i?.count} files queued again`)
});